import * as actionTypes from '../actionTypes'
import { updateObject } from '../shared/utility'

export const initialState = {
  users: {},
  assignableUserList: [],
  pagination: {
    page: 1,
    limit: 10,
    total_records: 0
  },
  loading: false
}

// ==============================|| CUSTOMIZATION REDUCER ||============================== //
const assignableUserReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.RESET_STATE:
      return initialState

    case actionTypes.GETTING_ASSIGNABLE_USERS_SUCCESS:
      const currentList = state.assignableUserList || []
      const newUsers = action?.data?.users || []

      return updateObject(state, {
        loading: false,
        assignableUserList: action.isLoadMore ? [...currentList, ...newUsers] : newUsers,
        pagination: {
          page: action?.data?.page,
          limit: action?.data?.limit,
          total_records: action?.data?.total_records
        }
      })

    case actionTypes.GETTING_ASSIGNABLE_USERS_FAILURE:
      return updateObject(state, {
        loading: false,
        users: {}
      })

    default:
      return state
  }
}

export default assignableUserReducer
